"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIconButtonsStyles = exports.privateCommon = exports.iconButtonVars = exports.iconButtonCommon = exports.getIconButtonColors = void 0;
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _Theme = require("../../themes/Theme");
var _getPseudoStyles = _interopRequireDefault(require("../../utils/getPseudoStyles"));
var _getRgbaFromHex = _interopRequireDefault(require("../../utils/getRgbaFromHex"));
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } /**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var iconButtonCommon = exports.iconButtonCommon = ["height", "width"].concat(_toConsumableArray(_commonProps.defaultCommonProps));
var privateCommon = exports.privateCommon = ["padding"];
var iconButtonVars = exports.iconButtonVars = (0, _initVars.default)({
  applied: [].concat(_toConsumableArray(iconButtonCommon), privateCommon),
  variables: [{
    key: "borderWidth"
  }, {
    key: "colorsBorderColor"
  }, {
    key: "svgFill"
  }, {
    key: "hoverColor"
  }, {
    key: "selectedBorder"
  }, {
    key: "selectedHover"
  }]
});
var TRANSITION_TIME = 300;
var styles = function styles(_ref) {
  var colors = _ref.colors;
  return {
    variables: iconButtonVars.styles,
    root: {
      backgroundColor: "transparent",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      outline: "none",
      border: 0,
      margin: 0,
      cursor: "pointer",
      userSelect: "none",
      verticalAlign: "middle",
      textDecoration: "none",
      textAlign: "center",
      borderRadius: "50%",
      boxSizing: "border-box",
      flexShrink: 0,
      "&:disabled, &:disabled svg": {
        pointerEvents: "none",
        cursor: "default",
        fill: colors.baseContrast020,
        borderColor: colors.baseContrast020
      }
    },
    filled: {
      backgroundColor: colors.themeBase,
      "&:disabled": {
        backgroundColor: colors.baseContrast015
      }
    },
    outlined: {
      borderStyle: "solid",
      borderWidth: iconButtonVars.get("borderWidth")
    },
    shadowOn: {
      boxShadow: "0 1px 2px 0 ".concat((0, _getRgbaFromHex.default)(colors.baseShadow, 0.5))
    },
    shadowHover: _objectSpread({}, (0, _getPseudoStyles.default)({
      hover: {
        boxShadow: "0 1px 2px 0 ".concat((0, _getRgbaFromHex.default)(colors.baseShadow, 0.5))
      }
    })),
    svgIcon: {
      display: "inline-block",
      verticalAlign: "middle"
    },
    colors: _objectSpread(_objectSpread({
      transitionDuration: TRANSITION_TIME,
      transitionProperty: ["box-shadow", "border-color"],
      borderColor: iconButtonVars.get("colorsBorderColor"),
      "& svg": {
        transitionDuration: TRANSITION_TIME,
        transitionProperty: "fill",
        fill: iconButtonVars.get("svgFill")
      }
    }, (0, _getPseudoStyles.default)({
      hover: {
        borderColor: iconButtonVars.get("hoverColor"),
        "& svg": {
          fill: iconButtonVars.get("hoverColor")
        }
      }
    })), {}, {
      "&:focus-visible": {
        borderColor: iconButtonVars.get("selectedBorder"),
        "& svg": {
          fill: iconButtonVars.get("selectedHover")
        }
      }
    })
  };
};
var getIconButtonColors = exports.getIconButtonColors = function getIconButtonColors(type, colors, fill, isNewTheme, themeMode) {
  switch (type) {
    case "default":
      {
        var fillColor = fill ? colors[fill] || fill : null;
        if (!fill && isNewTheme && themeMode === _Theme.ThemeMode.light) {
          return {
            baseBorder: colors.baseContrast070,
            baseSvg: colors.baseContrast070,
            baseHover: colors.baseContrast085,
            selectedBorder: colors.primary,
            selectedSvg: colors.baseContrast100,
            selectedHover: colors.baseContrast100
          };
        }
        return {
          baseBorder: fillColor !== null && fillColor !== void 0 ? fillColor : colors.baseInvariant,
          baseSvg: fillColor !== null && fillColor !== void 0 ? fillColor : colors.baseInvariant,
          baseHover: colors.baseContrast100,
          selectedBorder: fillColor !== null && fillColor !== void 0 ? fillColor : colors.primary,
          selectedSvg: colors.baseContrast100,
          selectedHover: colors.baseContrast100
        };
      }
    case "error":
      {
        return {
          baseBorder: colors.baseInvariant,
          baseSvg: colors.baseInvariant,
          baseHover: colors.alert,
          selectedBorder: colors.alert,
          selectedSvg: colors.alert,
          selectedHover: (0, _getRgbaFromHex.default)(colors.alert, 0.75)
        };
      }
    case "highContrast":
      {
        return {
          baseBorder: isNewTheme ? colors.baseContrast070 : colors.baseContrast100,
          baseSvg: isNewTheme ? colors.baseContrast090 : colors.baseContrast100,
          baseHover: isNewTheme ? colors.baseContrast100 : colors.baseContrast070,
          selectedBorder: colors.primary,
          selectedSvg: colors.primary,
          selectedHover: colors.baseContrast100
        };
      }
    default:
      {
        var _colors$type;
        return {
          baseBorder: isNewTheme ? colors.baseContrast070 : colors.baseInvariant,
          baseSvg: isNewTheme ? colors.baseContrast070 : colors.baseInvariant,
          baseHover: colors[type],
          selectedBorder: colors[type],
          selectedSvg: colors[type],
          selectedHover: (0, _getRgbaFromHex.default)((_colors$type = colors[type]) !== null && _colors$type !== void 0 ? _colors$type : type, 0.75)
        };
      }
  }
};
var useIconButtonsStyles = exports.useIconButtonsStyles = (0, _createUseStyles.default)(styles, {
  name: "IconButton"
});